<template>
  <div :class="wrapperClasses">
    <div v-if="isAuthenticated" id="nav_sidebar" title="Sidebar">
      <div class="company-info">
        <img :src="merchantLogo" />
        <div class="nav-menu-icon" @click="setIsSidebarOpen(false)">
          <BIcon icon="x" class="nav-menu-icon" />
        </div>
      </div>
      <div id="buttons" class="v-flex" center>
        <b-button variant="red" pill @click="showPaymentModal"
          ><b-icon icon="cash" /> Send Payment Request</b-button
        >
      </div>
      <div>
        <SidebarItem
          v-for="link of sideBarLinks"
          :key="link.label"
          :linkData="link"
        />
      </div>
      <div><SendPayment /></div>
    </div>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem'
import SendPayment from '@/components/Elements/SendPayment/SendPayment.vue'
import { mapMutations } from 'vuex'
import sidebarLinks from './sidebar-links'
import legacyUserLinks from './legacyUserLinks'

export default {
  components: {
    SendPayment,
    SidebarItem
  },
  data() {
    return {
      sidebarLinks
    }
  },
  methods: {
    ...mapMutations(['setIsSidebarOpen']),
    showPaymentModal() {
      this.$bvModal.show('payment-modal')
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    wrapperClasses() {
      return [
        'sidebar-wrapper',
        this.$store.state.isSidebarOpen ? 'opened' : 'closed'
      ]
    },
    sideBarLinks() {
      if (this.$store.getters.isLegacyUser) {
        return legacyUserLinks.call(this)
      } else if (this.$store.getters.profile) {
        return sidebarLinks.call(this)
      } else {
        return []
      }
    },
    merchantLogo() {
      return this.$store.getters.profileMerchantLogo
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar-wrapper {
  display: flex;
  flex-direction: column;
  overflow: auto;
  overflow-x: hidden;
  width: 280px;
  transition: 222ms width ease-in-out;
  @include simple-scrollbar;

  &.closed {
    width: 0px;
  }
}

#nav_sidebar {
  background: $blue;
  width: 280px;
  flex: 1;
  border-right: solid 1px lighten($blue, 50%);
}

.company-info {
  padding: 20px;
  flex-direction: column;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: solid 1px lighten($blue, 50%);
  height: 105px;
  position: relative;

  img {
    height: 80px;
    width: 150px;
    object-fit: contain;
  }

  .b-skeleton {
    height: 85px;
    width: 150px;
    max-width: 100%;
  }
}

.nav-menu-icon {
  position: absolute;
  right: 0;
  top: 0;
  background: transparent;
  opacity: 1;
}

#buttons {
  padding: 10px;
}
</style>
